/* eslint-disable react/jsx-props-no-spreading */
import { CloseOutlined } from '@ant-design/icons';
import { ColumnType } from 'antd/lib/table';
import { Button, Checkbox, Form } from 'antd';
import { NamePath } from 'rc-field-form/lib/interface';
import { FormHealthCondition } from '../../features/ICDCode/component/ICDTableComponent/ICDTableComponent';
import { PatientDiagnosesEnumComponent } from '../../enumComponent/PatientDiagnosesEnumComponent/PatientDiagnosesEnumComponent';
import { ICDProgramCheckboxFormItemComponent } from '../../features/ICDCode/component/ICDProgramCheckboxFormItem/ICDProgramCheckboxFormItem';

export const makeRemoveICDColumn = (
  removeFunction: (index: number) => void,
  disabled?: boolean,
  isEdit?: boolean,
): ColumnType<FormHealthCondition> => ({
  key: 'removeAction',
  dataIndex: 'code',
  width: '6%',
  render: (_, __, index: number) => (isEdit ? (
    <Button
      type="text"
      onClick={() => removeFunction(index)}
      disabled={disabled}
    >
      <CloseOutlined />
    </Button>
  ) : null),
});

const makeFormItemName = (
  record: FormHealthCondition,
  itemName: string,
) => [record.formField?.name, itemName] as NamePath;

export const icdTableColumns = (
  disabled?: boolean,
) => ({
  code: () => ({
    key: 'code',
    dataIndex: 'code',
    width: '12%',
    title: 'Code',
    render: (text: string, record: FormHealthCondition) => (
      !record.formField
        ? <div>{text}</div>
        : (
          <Form.Item
            {...record.formField}
            name={makeFormItemName(record, 'code')}
          >
            <div>{text}</div>
          </Form.Item>
        )
    ),
  }),
  diagnosis: () => ({
    key: 'diagnosis',
    dataIndex: 'diagnosis',
    width: '12%',
    title: 'Dx',
    render: (text: string, record: FormHealthCondition) => (
      !record.formField
        ? (
          <PatientDiagnosesEnumComponent
            value={record.diagnosis}
          />
        ) : (
          <Form.Item
            {...record.formField}
            name={makeFormItemName(record, 'diagnosis')}
          >
            <PatientDiagnosesEnumComponent
              value={record.diagnosis}
            />
          </Form.Item>
        )
    ),
  }),
  condition: () => ({
    key: 'condition',
    dataIndex: 'condition',
    title: 'Condition',
    render: (text: string, record: FormHealthCondition) => (
      !record.formField
        ? <div>{text}</div>
        : (
          <Form.Item
            {...record.formField}
            name={makeFormItemName(record, 'condition')}
          >
            <div>{text}</div>
          </Form.Item>
        )
    ),
  }),
  isBillable: () => ({
    key: 'isBillable',
    dataIndex: 'isBillable',
    title: 'Billable',
    width: '10%',
    render: (
      isBillable: boolean | null,
      record: FormHealthCondition,
    ) => (
      (!record.formField)
        ? <Checkbox checked={!!isBillable} disabled={disabled} />
        : (
          <ICDProgramCheckboxFormItemComponent
            {...record.formField}
            name={makeFormItemName(record, 'isBillable')}
            disabled={disabled}
          />
        )
    ),
  }),
});
